import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "../../../hooks/useAuth";
import './style.scss';
import {Helmet} from "react-helmet";
import { useRecoilState } from "recoil";
import { tokenState } from "../../../atoms/token";
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import APIService from "../../../services/api.service";
import { PendingTicDialog } from "../../dialogs/Pending-Tic-Dialog";
import { add } from "lodash";

const PendingTicNum = () => {
  const { user } = useAuth();

  const [showDialog, setShowDialog] = useState(false);
  const [reload, setReload] = useState(false);
  const [row, setRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [token, setToken] = useRecoilState(tokenState);
  const [pendingTicNums, setPendingTicNums] = useState([]);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('searc state', state);
    console.log('use ef rows', selectedRows);
    getPendingTicNums();

    setReload(false);
  }, [reload]);

  const getPendingTicNums = () => { 
    const url = `${environment.eticApiUrl}getRequestedTicNumbers?status=requested&currentPage=1&pageSize=1000`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      console.log('orders', res);
      setPendingTicNums(res.data.sort((a, b) => (a.createdDateDate > b.createdDate) ? -1 : 1));
      setLoading(false);
    });
  }

  const handleRowBtnClick = (event, rowParams) => { 
    setRow(rowParams.row);
    setShowDialog(true);
  }

  const handleCancelClick = () => { 
    setShowDialog(false);
    setRow(null);
    setLoading(true);
    getPendingTicNums();
  }

  const handleApproveBtnClick = (form) => { 
    const addUrl = `${environment.eticApiUrl}/api/etic/UpdateRequestedTicNumber/${row.id}`;
    const addApiService = new APIService<any>(axios, new CacheService, addUrl, token);

    addApiService.add(form).then((res:any) => { 
      console.log('update res', res);

      const url = `${environment.eticApiUrl}/api/etic/UpdateRequestedTicNumber/${row.id}?action=approve`;
      const apiService = new APIService<any>(axios, new CacheService, url, token);

      apiService.getAnyAsync().then((res:any) => {
        console.log('approve res', res);
      });
    });
    
  }

  const handleDeleteBtnClick = (event, rowParams) => { 
    console.log('delete row', rowParams.row);
    const url = `${environment.eticApiUrl}UpdateRequestedTicNumber/${rowParams.row.id}?action=delete`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      setLoading(true);
      getPendingTicNums();
    });
  }

  const formatDate = (date) => { 
    let d = new Date(date);
    return d.toLocaleDateString();
  }

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'Id', width: 100 },
    { field: 'parkName', headerName: 'Park', width: 200 },
    { field: 'title', headerName: 'Title', width: 200 },
    { field: 'infoType', headerName: 'Info Type', width: 100 },
    { field: 'pmisNumber', headerName: 'PMIS #', width: 100 },
    { field: 'comments', headerName: 'Comments', width: 200 },
    { field: 'createdDate', headerName: 'Create Date', width: 150 },
    { field: 'userId', headerName: 'Change Requestor', width: 150 },
    { field: 'edit', headerName: 'Edit',
    hideSortIcons: true,
    width: 150,
    renderCell: (cellValues) => {
      return (
        <Button
          variant={"contained"} 
          color={"primary"}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleRowBtnClick(event, cellValues);
          }}          
          startIcon={<FontAwesomeIcon icon={["fas", "edit"]}/>}
        >
          Edit
        </Button>
      );
    }
    },
    { field: 'delete', headerName: 'Delete',
    hideSortIcons: true,
    width: 150,
    renderCell: (cellValues) => {
      return (
        <Button
          variant={"contained"} 
          color={"primary"}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            handleDeleteBtnClick(event, cellValues);
          }}          
          startIcon={<FontAwesomeIcon icon={["fas", "trash"]}/>}
        >
          Delete
        </Button>
      );
    }
  },
  ];
  
  return (
    <>
    {/* <h1>User Uploads: {user?.profile?.name}</h1> */}
      <Helmet>
        <meta charSet="utf-8"/>
        <title>Pending TIC Numbers</title>
      </Helmet>
    <h1 className="center">Pending TIC Numbers</h1>

      <div className="search-results">
        {showDialog && <PendingTicDialog row={row} handleCancelClick={handleCancelClick} handleApproveBtnClick={handleApproveBtnClick} />}
        
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
             sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
             '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
             '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
             '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
            }}
            rows={pendingTicNums.map((result, index) => (
              {
                id: result?.id,
                userId: result?.userId,
                title: result?.title,
                infoType: result?.infoType,
                createdDate: formatDate(result?.createdDate),
                parkName: result?.parkName,
                pmisNumber: result?.pmisNumber,
                parkId: result?.parkId,
                comments: result?.comments,
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 50 },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            
            loading={loading}
          />
        </div>
      </div>
    </>
  );
}

export default PendingTicNum;